export default ['kpoKwu', 'declarationKwu', 'privateKwu']
